import { render, staticRenderFns } from "./StockPropertiesButonsCellRenderer.vue?vue&type=template&id=70df3a99"
import script from "./StockPropertiesButonsCellRenderer.vue?vue&type=script&lang=js"
export * from "./StockPropertiesButonsCellRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports